export default __webpack_public_path__ + "static/media/brandSafety.ae684ef7.png";